/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import Link from '@material-ui/core/Link';
import { withStyles } from '@material-ui/core';
import { Location } from '@tmna-ct/ipapps-core-js';
import styles from './styles';

class LocationServices extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { classes } = this.props;
    const location = new Location();

    location.latitude = '33.081601';
    location.longitude = '-96.841184';

    const {
      scheme: { scheme },
    } = location;

    return (
      <div className={classes.container}>
        <br />
        <br />
        <h3>Set navigation destination:</h3>
        <br />
        <p>
          Action to test scheme to set a navigation destination, tester should click Link and be
          able to set a navigation destination sending it to Navi Core.
        </p>
        <br />
        <Link href={scheme}>{`${scheme}`}</Link>
        <br />
        <br />
      </div>
    );
  }
}

LocationServices.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(LocationServices);
